import React from "react";

import Dialog from "@material-ui/core/Dialog";

import DupontButton from "components/DupontButton";
import { OverlayLoader } from "components/PageLoading";
import RenderMandatoryField from "components/RequiredField";

import "./index.scss";

export const DIALOG_ACTIONS = {
  CONFIRM: "CONFIRM",
  CANCEL: "CANCEL",
  RESET: "RESET",
  SETASDEFAULT: "SETASDEFAULT"
};

export default function DupontDialog(props) {
  const {
    open,
    onClose,
    title,
    customTitle,
    confirmBtnText,
    resetBtnText,
    customClass,
    confirmDisabled,
    defaultBtnText,
    type,
    subTitle,
    isOverlayLoader,
    showisRequired = false,
    maxWidth,
    titleClassName = "",
    disableBackdropClick = false
  } = props;

  const cancelBtnText = props.cancelBtnText || "Cancel";
  const btnColor = type === "primary" ? "white" : type;

  const closeBtnHandler = () => onClose(DIALOG_ACTIONS.CANCEL);
  const confirmBtnHandler = () => onClose(DIALOG_ACTIONS.CONFIRM);
  const resetBtnHandler = () => onClose(DIALOG_ACTIONS.RESET);
  const setAsDefaultHandler = () => onClose(DIALOG_ACTIONS.SETASDEFAULT);

  const getDialogTheme = () => {
    const dialogType = type || "default";
    return `dupont-dialog--${dialogType}`;
  };

  return (
    <Dialog onClose={closeBtnHandler} aria-labelledby={title} open={open} maxWidth={maxWidth} disableBackdropClick={disableBackdropClick}>
      {isOverlayLoader && <OverlayLoader />}
      <div className={`dupont-dialog ${getDialogTheme()} ${customClass || ""}`}>
        <header>
          <div className={`dupont-dialog__title${titleClassName ? ` ${titleClassName}` : ""}`}> {title}</div>
          {customTitle && <div>{customTitle}</div>}
          <div className="dupont-dialog__subTitle" dangerouslySetInnerHTML={{ __html: subTitle }} />
          {showisRequired && <div className="dupont-dialog__subTitle dupont-dialog__fontBold">{<RenderMandatoryField />}</div>}
        </header>

        <main className={`dupont-dialog__body`}> {props.children} </main>
        <footer className="dupont-dialog__footer">
          <DupontButton id="cancelBtn" type={"secondary"} color={btnColor} onClick={closeBtnHandler} customClass="dupont-dialog__footer--btn-spacing">
            {cancelBtnText}
          </DupontButton>
          {defaultBtnText && (
            <DupontButton
              id="defaultBaselineBtn"
              type={"secondary"}
              color={btnColor}
              disabled={confirmDisabled}
              onClick={setAsDefaultHandler}
              customClass="dupont-dialog__footer--btn-spacing"
            >
              {defaultBtnText}
            </DupontButton>
          )}
          {resetBtnText && (
            <DupontButton
              id="resetBtn"
              type={"secondary"}
              color={btnColor}
              onClick={resetBtnHandler}
              customClass="dupont-dialog__footer--btn-spacing"
            >
              {resetBtnText}
            </DupontButton>
          )}
          {confirmBtnText && (
            <DupontButton
              id="submitBtn"
              type={"primary"}
              color={btnColor}
              disabled={confirmDisabled}
              onClick={confirmBtnHandler}
              customClass="dupont-dialog__footer--confirm-btn"
            >
              {confirmBtnText}
            </DupontButton>
          )}
        </footer>
      </div>
    </Dialog>
  );
}
